import { c as _c } from "react/compiler-runtime";
import Link from '@/components/elements/Link';
import { REDIRECT_URL } from '@/constants/config';
import useCartFinancials from '@/contexts/cartContext/hooks/useCartFinancials';
import useCartReservationInProgress from '@/contexts/cartContext/hooks/useCartReservationInProgress';
import useCurrency from '@/contexts/i18nContext/hooks/useCurrency';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { FGTMEventEnum } from '@/types/gtm';
import { FTunnelPageBookingTypeEnum } from '@/types/tunnel';
import getGTMECommerce from '@/utils/gtm/getGTMECommerce';
import pushGTMDataLayer from '@/utils/gtm/pushGTMDataLayer';
import { useEffect } from 'react';
import useTunnelBookingType from './context/hooks/useTunnelBookingType';
import useTunnelExperience from './context/hooks/useTunnelExperience';
const ConfirmationPage = () => {
    const $ = _c(26);
    const translate = useTranslate();
    let t0;
    if ($[0] !== translate) {
        t0 = translate("confirmation_page.title");
        $[0] = translate;
        $[1] = t0;
    }
    else {
        t0 = $[1];
    }
    const title = t0;
    let t1;
    if ($[2] !== translate) {
        t1 = translate("confirmation_page.email_sent");
        $[2] = translate;
        $[3] = t1;
    }
    else {
        t1 = $[3];
    }
    const text = t1;
    let t2;
    if ($[4] !== translate) {
        t2 = translate("confirmation_page.back_button.label");
        $[4] = translate;
        $[5] = t2;
    }
    else {
        t2 = $[5];
    }
    const btnLabel = t2;
    const { _key: currencyKey } = useCurrency();
    const { experience } = useTunnelExperience();
    const reservationInProgress = useCartReservationInProgress();
    const bookingType = useTunnelBookingType();
    const { paymentBehaviour, totalPrice, conversionAmount, discount } = useCartFinancials();
    let t3;
    let t4;
    if ($[6] !== bookingType || $[7] !== conversionAmount || $[8] !== currencyKey || $[9] !== discount || $[10] !== experience || $[11] !== paymentBehaviour || $[12] !== reservationInProgress || $[13] !== totalPrice) {
        t3 = () => {
            if (totalPrice != null) {
                setTimeout(() => {
                    const newDataLayer = getGTMECommerce({ bookingType, conversionAmount, currencyKey, discount, experience, paymentBehaviour, reservationInProgress, totalPrice });
                    pushGTMDataLayer({ ...newDataLayer, event: bookingType === FTunnelPageBookingTypeEnum.voucher ? FGTMEventEnum.purchase_gift_voucher : FGTMEventEnum.purchase });
                }, 100);
            }
        };
        t4 = [
            bookingType,
            conversionAmount,
            currencyKey,
            discount,
            experience,
            paymentBehaviour,
            reservationInProgress,
            totalPrice
        ];
        $[6] = bookingType;
        $[7] = conversionAmount;
        $[8] = currencyKey;
        $[9] = discount;
        $[10] = experience;
        $[11] = paymentBehaviour;
        $[12] = reservationInProgress;
        $[13] = totalPrice;
        $[14] = t3;
        $[15] = t4;
    }
    else {
        t3 = $[14];
        t4 = $[15];
    }
    useEffect(t3, t4);
    const handleReturnClick = _temp;
    let t5;
    if ($[16] !== title) {
        t5 = <h1 className="font-bold text-2xl mb-4">{title}</h1>;
        $[16] = title;
        $[17] = t5;
    }
    else {
        t5 = $[17];
    }
    let t6;
    if ($[18] !== text) {
        t6 = <p className="font-semibold text-gray-400">{text}</p>;
        $[18] = text;
        $[19] = t6;
    }
    else {
        t6 = $[19];
    }
    let t7;
    if ($[20] !== btnLabel) {
        t7 = REDIRECT_URL ?
            <div className="flex flex-row justify-center mt-8 ">
      <Link href={REDIRECT_URL} externalLink={true} className="btn btn-primary" preventDefault={true} onClick={handleReturnClick}>

        {btnLabel}
      </Link>
    </div> : null;
        $[20] = btnLabel;
        $[21] = t7;
    }
    else {
        t7 = $[21];
    }
    let t8;
    if ($[22] !== t5 || $[23] !== t6 || $[24] !== t7) {
        t8 = <div className="w-full h-100 border-b border-gray-100 flex flex-col justify-center items-center">{t5}{t6}{t7}
    </div>;
        $[22] = t5;
        $[23] = t6;
        $[24] = t7;
        $[25] = t8;
    }
    else {
        t8 = $[25];
    }
    return t8;
};
export default ConfirmationPage;
function _temp() { const topWindow = window.top ?? window; topWindow.location.replace(REDIRECT_URL ?? ""); }
